import { render, staticRenderFns } from "./Consultations.vue?vue&type=template&id=12dbac02&scoped=true&"
import script from "./Consultations.vue?vue&type=script&lang=js&"
export * from "./Consultations.vue?vue&type=script&lang=js&"
import style0 from "./Consultations.vue?vue&type=style&index=0&id=12dbac02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbac02",
  null
  
)

export default component.exports